document.addEventListener('DOMContentLoaded', function() {
  const giftCardForm = document.querySelector('[data-product-form]');
  if (!giftCardForm) return;

  const priceRadios = document.querySelectorAll('.gift-card-price-radio');
  const customAmountTrigger = document.querySelector('[data-trigger-custom-amount="true"]');
  const customAmountWrapper = document.querySelector('.product__form__custom-amount-wrapper');
  const customAmountInput = document.querySelector('.js-custom-amount-input');
  const customAmountError = document.querySelector('.product__form__custom-amount-error');
  const addToCartButton = document.querySelector('button[data-btn-add-to-cart]');
  const customAmountButton = document.querySelector('button[data-custom-amount-button]');
  const quantityInput = document.querySelector('.gift-card-quantity-input');
  const quantityMinus = document.querySelector('.gift-card-quantity-minus');
  const quantityPlus = document.querySelector('.gift-card-quantity-plus');
  const sendToGiftCheckbox = document.querySelector('#send-to-gift');
  const myEmailForm = document.querySelector('#my-email-form');
  const giftFormWrapper = document.querySelector('#gift-card-form');
  const quantityHidden = document.querySelector('#gift-card-quantity-hidden');
  const messageInput = document.querySelector('#gift-card-message');
  const charCount = document.querySelector('#gift-card-message-count');

  // Bounds are set per currency in Liquid (data-min / data-max)
  const customAmountMin = parseFloat(customAmountInput?.dataset.min) || 50;
  const customAmountMax = parseFloat(customAmountInput?.dataset.max) || 1000;
  const customAmountCurrency = customAmountInput?.dataset.currency || 'EUR';

  // Translated copy rendered by Liquid; the range error is the element's initial text
  const customAmountErrorText = customAmountError?.textContent.trim() || '';
  const customAmountRequestErrorText = customAmountError?.dataset.requestErrorText || customAmountErrorText;
  const customAmountButtonText = customAmountButton?.querySelector('.btn__text') || customAmountButton;
  const customAmountButtonLabel = customAmountButtonText?.textContent || '';
  const customAmountProcessingText = customAmountButton?.dataset.processingText || customAmountButtonLabel;

  function showCustomAmountError(message = customAmountErrorText) {
    if (!customAmountError) return;
    customAmountError.textContent = message;
    customAmountError.classList.remove('hidden');
  }

  // Validate custom amount input
  function validateCustomAmount(value) {
    const num = parseFloat(value);
    if (isNaN(num) || num < customAmountMin || num > customAmountMax) {
      return false;
    }
    return true;
  }

  // Update add to cart button state based on custom amount validation
  function updateAddToCartButtonState() {
    if (!addToCartButton) return;

    // If custom amount is not selected, button is enabled
    if (!customAmountTrigger || !customAmountTrigger.checked) {
      addToCartButton.disabled = false;
      return;
    }

    // Custom amount is selected, check if it's valid
    const value = customAmountInput?.value.trim() || '';
    const isValid = value !== '' && validateCustomAmount(value);

    addToCartButton.disabled = !isValid;
  }

  // Toggle custom amount wrapper visibility
  function toggleCustomAmountWrapper(show) {
    if (customAmountWrapper) {
      customAmountWrapper.classList.toggle('hidden', !show);
    }
    if (customAmountInput) {
      customAmountInput.disabled = !show;
      if (show) {
        customAmountInput.focus();
      }
    }
    if (customAmountError && !show) {
      customAmountError.classList.add('hidden');
    }
    // Show/hide buttons based on custom amount selection
    if (addToCartButton) {
      addToCartButton.classList.toggle('hidden', show);
    }
    if (customAmountButton) {
      customAmountButton.classList.toggle('hidden', !show);
    }
  }

  // Handle custom amount trigger (1€ variant)
  if (giftCardForm) {
    giftCardForm.addEventListener('change', function(e) {
      if (e.target && e.target.classList.contains('gift-card-price-radio')) {
        if (e.target.checked) {
          toggleCustomAmountWrapper(e.target.hasAttribute('data-trigger-custom-amount'));
          updateAddToCartButtonState();
        }
      }
    });

    // Check initial state on page load (check label for 'checked' attribute)
    const initialSelectedLabel = giftCardForm.querySelector('label.product__form__option__toggle[checked]');
    if (initialSelectedLabel) {
      const radioId = initialSelectedLabel.getAttribute('for');
      const selectedRadio = document.getElementById(radioId);
      if (selectedRadio && selectedRadio.hasAttribute('data-trigger-custom-amount')) {
        toggleCustomAmountWrapper(true);
      }
    }
    updateAddToCartButtonState();
  }

  // Handle custom amount input validation
  if (customAmountInput) {
    customAmountInput.addEventListener('input', function() {
      let value = this.value.replace(/[^0-9.]/g, '');
      const parts = value.split('.');
      if (parts.length > 2) {
        value = parts[0] + '.' + parts[1];
      }
      if (parts.length === 2 && parts[1].length > 2) {
        value = parts[0] + '.' + parts[1].substring(0, 2);
      }
      this.value = value;
      validateAndShowError();
      updateAddToCartButtonState();
    });

    customAmountInput.addEventListener('blur', function() {
      validateAndShowError();
      updateAddToCartButtonState();
    });

    function validateAndShowError() {
      const value = customAmountInput.value.trim();
      if (value === '') {
        if (customAmountError) {
          customAmountError.classList.add('hidden');
        }
        customAmountInput.removeAttribute('aria-invalid');
        return;
      }

      if (!validateCustomAmount(value)) {
        showCustomAmountError();
        customAmountInput.setAttribute('aria-invalid', 'true');
      } else {
        if (customAmountError) {
          customAmountError.classList.add('hidden');
        }
        customAmountInput.removeAttribute('aria-invalid');
      }
    }
  }

  // Quantity controls
  if (quantityMinus) {
    quantityMinus.addEventListener('click', function(e) {
      e.preventDefault();
      const current = parseInt(quantityInput.value, 10);
      if (current > 1) {
        quantityInput.value = current - 1;
        updateQuantityHidden();
      }
    });
  }

  if (quantityPlus) {
    quantityPlus.addEventListener('click', function(e) {
      e.preventDefault();
      const current = parseInt(quantityInput.value, 10);
      if (current < 999) {
        quantityInput.value = current + 1;
        updateQuantityHidden();
      }
    });
  }

  if (quantityInput) {
    quantityInput.addEventListener('change', updateQuantityHidden);
  }

  function updateQuantityHidden() {
    if (quantityHidden) {
      quantityHidden.value = quantityInput.value;
    }
  }

  // Send as gift toggle
  function updateGiftFormVisibility() {
    if (!sendToGiftCheckbox) return;

    if (sendToGiftCheckbox.checked) {
      if (myEmailForm) myEmailForm.classList.add('hidden');
      if (giftFormWrapper) giftFormWrapper.classList.remove('hidden');
      sendToGiftCheckbox.setAttribute('aria-expanded', 'true');
      enableRecipientFields();
    } else {
      if (myEmailForm) myEmailForm.classList.remove('hidden');
      if (giftFormWrapper) giftFormWrapper.classList.add('hidden');
      sendToGiftCheckbox.setAttribute('aria-expanded', 'false');
      disableRecipientFields();
    }
  }

  if (sendToGiftCheckbox) {
    sendToGiftCheckbox.addEventListener('change', function() {
      updateGiftFormVisibility();
      // Move focus to the first recipient field when the user opts in.
      if (this.checked) {
        const emailField = document.querySelector('#gift-card-recipient-email');
        if (emailField) emailField.focus();
      }
    });

    // Sync the initial UI/field state (covers browser-restored checkbox state).
    updateGiftFormVisibility();
  }

  // Disable recipient form fields when sending to self
  function disableRecipientFields() {
    const emailField = document.querySelector('#gift-card-recipient-email');
    const nameField = document.querySelector('#gift-card-recipient-name');
    const dateField = document.querySelector('#gift-card-send-date');
    
    if (emailField) {
      emailField.disabled = true;
      emailField.removeAttribute('name');
      emailField.value = '';
    }
    if (nameField) {
      nameField.disabled = true;
      nameField.removeAttribute('name');
      nameField.value = '';
    }
    if (dateField) {
      dateField.disabled = true;
      dateField.removeAttribute('name');
      dateField.value = '';
    }
    if (messageInput) {
      messageInput.disabled = true;
      messageInput.removeAttribute('name');
      messageInput.value = '';
    }

    // Remove control flag hidden input
    const controlFlag = giftCardForm.querySelector('input[name="properties[__shopify_send_gift_card_to_recipient]"]');
    if (controlFlag) {
      controlFlag.remove();
    }

    // Remove timezone offset
    const timezoneOffset = giftCardForm.querySelector('input[name="properties[__shopify_offset]"]');
    if (timezoneOffset) {
      timezoneOffset.remove();
    }
  }

  // Enable recipient form fields when sending to recipient
  function enableRecipientFields() {
    const emailField = document.querySelector('#gift-card-recipient-email');
    const nameField = document.querySelector('#gift-card-recipient-name');
    const dateField = document.querySelector('#gift-card-send-date');
    
    if (emailField) {
      emailField.disabled = false;
      emailField.setAttribute('name', 'properties[Recipient email]');
    }
    if (nameField) {
      nameField.disabled = false;
      nameField.setAttribute('name', 'properties[Recipient name]');
    }
    if (dateField) {
      dateField.disabled = false;
      dateField.setAttribute('name', 'properties[Send on]');
      setDateConstraints(dateField);
    }
    if (messageInput) {
      messageInput.disabled = false;
      messageInput.setAttribute('name', 'properties[Message]');
    }

    // Add control flag hidden input (tells Shopify this is a gift to recipient)
    let controlFlag = giftCardForm.querySelector('input[name="properties[__shopify_send_gift_card_to_recipient]"]');
    if (!controlFlag) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[__shopify_send_gift_card_to_recipient]';
      input.value = 'true';
      giftCardForm.appendChild(input);
    }

    // Add timezone offset
    let timezoneOffset = giftCardForm.querySelector('input[name="properties[__shopify_offset]"]');
    if (!timezoneOffset) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[__shopify_offset]';
      input.value = new Date().getTimezoneOffset().toString();
      giftCardForm.appendChild(input);
    }
  }

  // Set date constraints (min: today, max: +90 days)
  function setDateConstraints(dateField) {
    const today = new Date();
    const maxDate = new Date();
    maxDate.setDate(today.getDate() + 90);

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    dateField.setAttribute('min', formatDate(today));
    dateField.setAttribute('max', formatDate(maxDate));
  }

  // Message character counter
  if (messageInput && charCount) {
    messageInput.addEventListener('input', function() {
      charCount.textContent = this.value.length;
    });
  }

  // Function to submit custom amount
  function submitCustomAmount() {
    return new Promise((resolve, reject) => {
      // Check if custom amount trigger is selected - check both input.checked and label[checked]
      const isChecked = customAmountTrigger.checked || 
                       (customAmountTrigger.id && 
                        document.querySelector(`label[for="${customAmountTrigger.id}"][checked]`));
      
      if (!customAmountTrigger || !isChecked) {
        reject('Custom amount trigger not selected');
        return;
      }

      const customValue = customAmountInput.value.trim();
      
      // Validate: check if empty
      if (customValue === '') {
        showCustomAmountError();
        customAmountInput.setAttribute('aria-invalid', 'true');
        customAmountInput.focus();
        reject('Empty value');
        return;
      }
      
      // Validate amount
      if (!validateCustomAmount(customValue)) {
        showCustomAmountError();
        customAmountInput.setAttribute('aria-invalid', 'true');
        customAmountInput.focus();
        reject('Invalid amount');
        return;
      }

      const makeEndpoint = giftCardForm.getAttribute('data-make-endpoint');
      const productId = giftCardForm.getAttribute('data-product-id');
      
      // Disable button and show loading state
      if (customAmountButton) {
        customAmountButton.disabled = true;
        customAmountButtonText.textContent = customAmountProcessingText;
      }

      
      if (!makeEndpoint) {
        console.error('Make endpoint not configured');
        if (customAmountButton) {
          customAmountButton.disabled = false;
          customAmountButtonText.textContent = customAmountButtonLabel;
        }
        reject('No endpoint');
        return;
      }

      // Call Make webhook with custom amount
      fetch(makeEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          amount: parseFloat(customValue),
          currency: customAmountCurrency,
          productId: productId
        })
      })
      .then(response => response.json())
      .then(data => {
        // Check if Make webhook call was successful
        if (data.success === false) {
          throw new Error('Make webhook returned success: false');
        }

        // Expect variant_id in the response
        if (!data.variant_id) {
          throw new Error('No variant_id returned from Make webhook');
        }


        // Update the variant ID field (can be input or select)
        const idField = giftCardForm.querySelector('[name="id"]');
        if (idField) {
          // If it's a select, add the new option if it doesn't exist
          if (idField.tagName === 'SELECT') {
            const existingOption = idField.querySelector(`option[value="${data.variant_id}"]`);
            if (!existingOption) {
              const newOption = document.createElement('option');
              newOption.value = data.variant_id;
              newOption.textContent = `Custom Amount - ${customValue} ${customAmountCurrency}`;
              idField.appendChild(newOption);
            }
          }
          
          // Set the value to the new variant ID
          idField.value = data.variant_id;
        } else {
          console.error('Could not find [name="id"] field in form');
        }

        // Restore button state and resolve
        if (customAmountButton) {
          // customAmountButton.disabled = false;
          customAmountButtonText.textContent = customAmountButtonLabel;
        }
        resolve();
      })
      .catch(error => {
        console.error('Error calling Make webhook:', error);
        showCustomAmountError(customAmountRequestErrorText);
        if (customAmountButton) {
          customAmountButton.disabled = false;
          customAmountButtonText.textContent = customAmountButtonLabel;
        }
        customAmountInput.focus();
        reject(error);
      });
    });
  }

  // Handle custom amount button click
  if (customAmountButton) {
    customAmountButton.addEventListener('click', function(e) {
      e.preventDefault();
      submitCustomAmount()
        .then(async () => {
          // Custom amount processed successfully, add loading state
          const submitWrapper = giftCardForm.querySelector('.product__form__submit');
          if (submitWrapper) {
            submitWrapper.classList.add('is-loading');
          }
          if (customAmountButton) {
            customAmountButton.classList.add('is-loading');
          }
          
          // Give the newly created variant time to become purchasable (matches main)
          await new Promise((resolve) => setTimeout(resolve, 8000));

          // Simulate click on standard button
          if (addToCartButton) {
            addToCartButton.click();
          }
          
          // Wait for Shopify to process and complete, then reset UI to standard view
          setTimeout(() => {
            if (submitWrapper) {
              submitWrapper.classList.remove('is-loading');
            }
            if (customAmountButton) {
              customAmountButton.classList.remove('is-loading');
              customAmountButton.disabled = true;
            }
            // Reset to standard view (hide custom amount wrapper and show standard buttons)
            toggleCustomAmountWrapper(false);
          }, 1000);
        })
        .catch(error => {
          console.error('Custom amount submission failed:', error);
        });
    });
  }

  // Form validation on submit
  if (giftCardForm) {
    giftCardForm.addEventListener('submit', function(e) {
      // Custom amount is now handled by the custom amount button, so skip here
      if (customAmountTrigger && customAmountTrigger.checked) {
        // The custom amount button has already processed and called submit
        return true;
      }
      
      // Get selected send-to option
      const selectedSendTo = document.querySelector('input[name="send-to-option"]:checked');
      
      if (!selectedSendTo || selectedSendTo.value !== 'gift') {
        return true;
      }
    });
  }
});

